export const DEFAULT_CHANNEL = "ydemo";
export const ALTERNATIVE_CHANNEL = ["hotelux", "hoteluxjp"];
export const HostChannelMapsDev = {};
export const HostChannelMaps = {
  ...HostChannelMapsDev,
  "ydemo.ysys.biz": DEFAULT_CHANNEL,
  "booking.ytripos.com": DEFAULT_CHANNEL,
  "samepage.ytripos.com": "samepage",
  "mantourist.ytripos.com": "zhongzhi",
  "itis.ytripos.com": "itis",
  "www.luxury.itis.com.tw": "itis",
  "luxury.itis.com.tw": "itis",
  "charlotte.ytripos.com": "charlotte",
  "dc.ytripos.com": "dc",
  "localhost:8848": DEFAULT_CHANNEL,
  "dbs.ytripos.com": "dbs",
  "dragonpass3.ytripos.com": "dragonpass3",
  "dragonpass4.ytripos.com": "dragonpass4",
  "dragonpass5.ytripos.com": "dragonpass5",
  "grouphl.ytripos.com": "hlgp",
  "luxyglobal.ytripos.com": "luxyglobal",
  "starrides.ytripos.com": "starrides",
  "towa.ytripos.com": "towa",
  "hotels.charlottetravel.com": "charlotte",
  "travelhub.ytripos.com": "travelhub",
  "russiaexpress.ytripos.com": "russiaexpress",
  "abatu.ytripos.com": "Abatu",
  "booking.abatu.co": "Abatu",
  "samotour.ytripos.com": "ruexp",
  "r-express.ytripos.com": "ruexp",
  "greenocean.ytripos.com": "greenocean",
  "sbctravel.ytripos.com": "SBC Travel",
  "thaisky.ytripos.com": "thaisky",
  "yxyx.ytripos.com": "yxyx",
  "yango.ytripos.com": "yangao",
  "members.charlottetravel.com.hk": "charlotte",
  "m-members.charlottetravel.com.hk": "charlotte",
  "hotels.luxyglobaltour.com": "luxyglobal",
  "luxuryhotelchina.com": "luxuryhotelchina",
  "www.luxuryhotelchina.com": "luxuryhotelchina",
  "hotel.hotelux.com": "hotelux",
  "bkkbk.hotelux.com": "bangkokbank",
  "onetouch.ytripos.com": "onetouch",
  "worldsurprise.ytripos.com": "worldsurprise",
  "lebaitu.ytripos.com": "lebaitu"
};
export const HostChannelMapsAlternative = {
  "hotel.hotelux.com": ["hotelux", "hoteluxjp"]
};

export const getChannelKeyByHost = () => {
  const host = window.location.host;
  return HostChannelMaps[host];
};

export const getChannelKeyByHostAlternative = () => {
  const host = window.location.host;
  if (window.location.href.includes("channel-select")) {
    return HostChannelMapsAlternative[host];
  }
  return HostChannelMapsAlternative[host];
};
